<script>
  import { getContractValue, getContractJSONvalue } from "../utils.js";

  export let chain = undefined;
  export let contract;
  export let tokenId = undefined;
  export let member;
  export let args = undefined;
  export let tag = 'span';

  const args_str = args ?
    Object.entries(args).map(([ key, value ]) => `${ key }_${ value }`).join('_') :
    '';
  const id = `${ chain }_${ contract }${ tokenId ? `_${ tokenId }` : '' }_${ member }${ args_str ? `_${ args_str}` : '' }`;

  const getMember = async () => {
    chain = parseInt(chain);
    if (tokenId == null) { //check if undefined or null (see the double equal instead of triple)
      return await getContractValue(chain, contract, member, args);
    } else {
      return await getContractJSONvalue(chain, contract, tokenId, member, args);
    }
  }
</script>

<svelte:element this={ tag } { id } { ...$$restProps } class:lt-value={ true }>
  {#await getMember() then value}
    <slot value={ value }>{ value }</slot>
  {:catch error}
    <!-- promise was rejected -->
  {/await}
</svelte:element>